import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Avatar } from "primereact/avatar";
import { Tag } from "primereact/tag";
import { InputSwitch } from "primereact/inputswitch";
import { Divider } from "primereact/divider";
import { Badge } from "primereact/badge";

import OpenModalBtn from "Components/ModalApp/OpenModalBtn";
import Translate from "Components/Translate";

import { ONLINE, OFFLINE } from "Constant";

import patchItem from "Services/patchItem";

import driver from "../../assets/images/driver_icon.svg";

const getSeverity = (online) => (online ? "success" : "info");

const toggleDriverStatus = (code) => {
  const patchApi = `/front/driver/${code}/state`;
  patchItem(patchApi);
};

const getTaxiNumber = (data) => {
  if (!data) return "--";
  
  const carNumber = data.car_number || "";
  const regNumber = data.registration_number || "";
  
  if (!carNumber && !regNumber) return "--";
  if (!carNumber) return regNumber;
  if (!regNumber) return carNumber;
  
  return `${carNumber}/${regNumber}`;
};

export const gridItem = (data) => {
  const {
    code,
    completename,
    firstname,
    lastname,
    mail,
    phone,
    image,
    active,
    online,
    in_all_taxi,
    car_number,
    registration_number
  } = data;

  const selectedRow = {
    getLink: `/front/driver/${code}`,
    putLink: `/front/driver/${code}`,
  };
  const patchSelectedRow = {
    getLink: `/front/driver/${code}/avatar`,
    code,
  };

  const titleModal = `${firstname} ${lastname}`;

  return (
    <div className="col-12 sm:col-6 lg:col-12 xl:col-4 p-2" key={code}>
      <div className="p-4 border-1 surface-border surface-card border-round">
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
          <div className="flex align-items-center gap-2">
            {in_all_taxi ? (
              <Tag value="In All Taxi" severity="warning" />
            ) : (
              <Tag value={getTaxiNumber(data)} severity="info" />
            )}
          </div>
          <Tag
            value={
              online ? (
                <Translate>{ONLINE}</Translate>
              ) : (
                <Translate>{OFFLINE}</Translate>
              )
            }
            severity={getSeverity(online)}
          />
        </div>
        <Divider />
        <div className="flex flex-column align-items-center gap-1">
          <OpenModalBtn
            type="editUserImg"
            title={titleModal}
            data={patchSelectedRow}
          >
            <Avatar
              className="p-overlay-badge custom-avatar"
              image={image ?? driver}
              shape={image ? "circle" : ""}
              style={{ cursor: "pointer" }}
            >
              <Badge
                value={<i className="pi pi-cog"></i>}
                className="custom-badge"
              ></Badge>
            </Avatar>
          </OpenModalBtn>
          <div className="text-2xl font-bold">{completename ?? "--"}</div>
          <div className="text-1xl font-bold">{phone}</div>
        </div>
        <Divider />
        <div className="flex align-items-center justify-content-between">
          <InputSwitch
            inputId={`driver-${code}`}
            checked={active}
            onChange={() => toggleDriverStatus(code)}
          />
          <OpenModalBtn title={titleModal} type="editUser" data={selectedRow}>
            <Button icon="pi pi-pencil" className="p-button-rounded text-white" />
          </OpenModalBtn>
        </div>
      </div>
    </div>
  );
};

export const listItem = (data, index) => {
  const {
    code,
    completename,
    firstname,
    lastname,
    mail,
    phone,
    image,
    active,
    online,
    in_all_taxi,
    car_number,
    registration_number
  } = data;

  const selectedRow = {
    getLink: `/front/driver/${code}`,
    putLink: `/front/driver/${code}`,
    code,
  };

  const titleModal = `${firstname} ${lastname}`;

  const patchSelectedRow = {
    getLink: `/front/driver/${code}/avatar`,
    code,
  };
  return (
    <div className="col-12" key={code}>
      <div
        className={classNames(
          "flex flex-column xl:flex-row p-4 gap-4 surface-card",
          { "border-top-1 surface-border": index !== 0 }
        )}
      >
        <div className="flex align-items-center gap-3">
          <OpenModalBtn
            type="editUserImg"
            title={titleModal}
            data={patchSelectedRow}
          >
            <Avatar
              className="p-overlay-badge custom-avatar"
              image={image ?? driver}
              shape={image ? "circle" : ""}
              style={{ cursor: "pointer" }}
            >
              <Badge
                value={<i className="pi pi-cog"></i>}
                className="custom-badge"
              />
            </Avatar>
          </OpenModalBtn>
          <div className="text-xl font-bold">
            {completename}
            <div className="flex align-items-center gap-2">
              {in_all_taxi ? (
                <Tag value="In All Taxi" severity="warning" />
              ) : (
                <Tag value={getTaxiNumber(data)} severity="info" />
              )}
            </div>
            <div className="flex align-items-center gap-2">
              <span className="font-semibold">{phone ?? "--"}</span>
            </div>
            <Tag
              value={
                online ? (
                  <Translate>{ONLINE}</Translate>
                ) : (
                  <Translate>{OFFLINE}</Translate>
                )
              }
              severity={getSeverity(online)}
            />
          </div>
        </div>
        <div className="flex flex-column xl:align-items-end gap-3 ml-auto">
          <OpenModalBtn type="editUser" data={selectedRow} title={titleModal}>
            <Button icon="pi pi-pencil" className="p-button-rounded" />
          </OpenModalBtn>
          <InputSwitch
            inputId={`driver-${code}`}
            checked={active}
            onChange={() => toggleDriverStatus(code)}
          />
        </div>
      </div>
    </div>
  );
};
